import * as Sentry from "@sentry/react";

// Environments where Sentry must stay silent — local dev and unit tests. Mirrors the backend's
// DISABLED_ENVS so the two sides agree on what "not a real environment" means.
const DISABLED_ENVIRONMENTS = new Set(["local", "test"]);

export interface InitSentryConfig {
  /** Empty disables Sentry entirely (no network, no replay). */
  dsn?: string;
  environment: string;
  release: string;
  /** Origins that receive `sentry-trace`/`baggage` headers (the backend API). */
  tracePropagationTargets: (string | RegExp)[];
  tracesSampleRate: number;
  replaysSessionSampleRate: number;
  replaysOnErrorSampleRate: number;
}

/**
 * Initializes the browser Sentry SDK. Config is passed in so the package stays env-agnostic.
 * See core/docs/architecture/observability.md.
 */
export function initSentry(config: InitSentryConfig): void {
  Sentry.init({
    dsn: config.dsn,
    enabled: !!config.dsn && !DISABLED_ENVIRONMENTS.has(config.environment),
    environment: config.environment,
    release: config.release,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracePropagationTargets: config.tracePropagationTargets,
    tracesSampleRate: config.tracesSampleRate,
    replaysSessionSampleRate: config.replaysSessionSampleRate,
    replaysOnErrorSampleRate: config.replaysOnErrorSampleRate,
  });
}
